export type SettingsSection = 'profile' | 'security' | 'preferences' | 'byok' | 'workspace' | 'billing' | 'privacy';

const sectionOrder: SettingsSection[] = ['profile', 'security', 'preferences', 'byok', 'workspace', 'billing', 'privacy'];

export function isSettingsSection(value: string | undefined): value is SettingsSection {
  return Boolean(value && sectionOrder.includes(value as SettingsSection));
}

